// extracted by mini-css-extract-plugin
export default {"app":"lwqPs","scrollable":"uA3pX","baseStyles":"I-o6r","mobileBaseStyles":"vmP35"};